import {useConfirm} from '@primer/react'
import {useCallback} from 'react'

import {LABELS} from '../constants'

interface UseConfirmDiscardChangesOptions {
  isDirty: boolean
}

interface UseConfirmDiscardChangesReturn {
  confirmDiscardIfDirty: () => Promise<boolean>
}

export function useConfirmDiscardChanges({isDirty}: UseConfirmDiscardChangesOptions): UseConfirmDiscardChangesReturn {
  const confirm = useConfirm()

  const confirmDiscardIfDirty = useCallback(async (): Promise<boolean> => {
    if (!isDirty) return true

    return confirm({
      title: LABELS.views.unsavedChangesTitle,
      content: LABELS.views.unsavedChangesContent,
      confirmButtonContent: LABELS.views.unsavedChangesConfirm,
      cancelButtonContent: LABELS.views.unsavedChangesCancel,
      confirmButtonType: 'danger',
    })
  }, [confirm, isDirty])

  return {confirmDiscardIfDirty}
}
